import { PayloadAction } from '../../../../store.model';
import { ViewGroup } from '../model/view-group.model';
import { ViewTaskItem } from '../model/view-task-item.model';
import { ActionType } from '../task-list-dialog.action';
import { TaskListDialogState } from '../task-list-dialog.state';

import { EditItem } from './edit-item.action';

export function editItemReducer(
    state: TaskListDialogState,
    action: PayloadAction<ActionType, EditItem>,
): TaskListDialogState {
    try {
        const nextGroups = state.groups.map<ViewGroup>((g) => {
            return {
                ...g,
                tasks: g.tasks.map<ViewTaskItem>((t) => {
                    if (t.msftTaskId === action.payload.msftTaskId) {
                        return { ...t, editing: action.payload.edit };
                    }
                    return t;
                }),
            };
        });
        return {
            ...state,
            groups: nextGroups,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
